import {autoRegister} from "../../container";
import {DefaultRenderer, MarkerClusterer, SuperClusterAlgorithm} from "@googlemaps/markerclusterer";
import {ColorScheme} from "../../common/colorSchemeService";

@autoRegister()
export class GoogleMapsFactory {

    public constructor(
        private markerClusterer: any = MarkerClusterer,
        private clusterAlgorithm: any = SuperClusterAlgorithm) {
    }

    public createMap(element: HTMLElement, options: google.maps.MapOptions): google.maps.Map {
        return new google.maps.Map(element, options);
    }

    public createMarker(options: google.maps.marker.AdvancedMarkerElementOptions): google.maps.marker.AdvancedMarkerElement {
        return new google.maps.marker.AdvancedMarkerElement(options);
    }

    public createMarkerClusterer(map: google.maps.Map, markers: google.maps.marker.AdvancedMarkerElement[], renderer: DefaultRenderer): MarkerClusterer {
        return new this.markerClusterer({
            map: map,
            markers: markers,
            algorithm: new this.clusterAlgorithm({radius: 200}),
            renderer: renderer
        });
    }

    public createLatLng(lat: number, lng: number): google.maps.LatLng {
        return new google.maps.LatLng({
            lat: lat,
            lng: lng
        });
    }

    public createPoint(x: number, y: number): google.maps.Point {
        return new google.maps.Point(x, y);
    }

    public createRenderingTypeFor(mapType: string): google.maps.RenderingType {
        if (mapType === "roadmap") {
            return google.maps.RenderingType.VECTOR;
        } else {
            return google.maps.RenderingType.RASTER;
        }
    }

    public createColorScheme(colorScheme: ColorScheme): google.maps.ColorScheme {
        if (colorScheme === ColorScheme.DARK) {
            return google.maps.ColorScheme.DARK;
        }
        return google.maps.ColorScheme.LIGHT;
    }

    public createPolyline(map: google.maps.Map, coordinates: google.maps.LatLng[], color: string): google.maps.Polyline {
        return new google.maps.Polyline({
            map: map,
            path: coordinates,
            clickable: false,
            strokeColor: color
        });
    }

    public createPolygon(map: google.maps.Map, coordinates: google.maps.LatLng[], color: string): google.maps.Polygon {
        return new google.maps.Polygon({
            map: map,
            paths: [coordinates],
            clickable: false,
            strokeColor: color,
            fillColor: color
        });
    }
}